var updateCludoSearchTitle = function () {
    function updatePageTitle() {
        if (window.location.href.includes("search")) {
            const urlFragment = window.location.hash
            if (!urlFragment) return

            const cludoQuery = urlFragment.match(/(?<=cludoquery=)(.*?)(?=&)/gi)[0].replaceAll("%20", " ")
            const cludoPage = urlFragment.match(/(?<=cludopage=)(.*?)(?=&)/gi)
            const cludoFilter = urlFragment.match(/(?<=cludocategory=)(.*?)(?=&)/gi)
            const cludoSort = urlFragment.match(/(?<=cludosort=)(.*?)(?=&)/gi) ?? "relevance"

            const sortedBy = {
                relevance: "sorted by relevance",
                "date_date%3Dasc": "sorted by oldest",
                "date_date%3Ddesc": "sorted by newest"
            }

            document.title = `Search results for '${cludoQuery}', page number ${cludoPage}, ${cludoFilter ? `filtered by '${cludoFilter[0].replaceAll("%20", " ").replaceAll(",", ", ")}'` : ''} ${sortedBy[cludoSort]} | Islington`
        }

        window.addEventListener("hashchange", updatePageTitle)
    }
        updatePageTitle()

}

